import React, {useState} from "react";
import {useAuth} from "../context/AuthContext";
import {Alert, Box, Button, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {LogoCardView} from "../../../common/components/LogoCardView";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import {auth} from "../../../FirebaseConfig";

interface LoginPageProps {
    onLoginSuccess?: () => void;
}

export const LoginPage: React.FC<LoginPageProps> = ({ onLoginSuccess }) => {

    const { setFirebaseUser } = useAuth();
    const [error, setError] = useState<string>("");
    const theme = useTheme();

    const handleGoogleLogin = async () => {
        try {
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);
            const token = await result.user.getIdToken();
            setFirebaseUser(result.user, token);
            onLoginSuccess?.();
        } catch (err) {
            setError(`Google Sign-In failed. Please try again. ${err}`);
        }
    };

    return (
        <LogoCardView>
            <Box sx={{ textAlign: "center", mb: 4 }}>
                <Typography variant="body1" color="text.secondary">
                    Sign in to your account to continue
                </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mb: 2 }}>
                <Button
                    variant="outlined"
                    onClick={handleGoogleLogin}
                    sx={{
                        width: "100%",
                        height: 40,
                        textTransform: "none",
                        color: theme.custom.googleButton.text,
                        borderColor: theme.custom.googleButton.border,
                        backgroundColor: theme.custom.googleButton.background,
                        "&:hover": {
                            backgroundColor: theme.custom.googleButton.hoverBackground,
                            borderColor: theme.custom.googleButton.border,
                        },
                        fontWeight: 500,
                        fontSize: 14,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1, // space between logo and text
                    }}
                >
                    <Box
                        component="img"
                        src="https://developers.google.com/identity/images/g-logo.png"
                        alt="Google logo"
                        sx={{ width: 18, height: 18 }}
                    />
                    Sign in with Google
                </Button>
            </Box>

            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        </LogoCardView>
    )

};